import React, {Component} from 'react';
import _ from 'lodash';
import {FormattedMessage} from "react-intl";
import onClickOutside from 'react-onclickoutside';

import misc from '../../misc';

// Internet Explorer 6-11
let isIE = /*@cc_on!@*/false || !!document.documentMode;
// https://stackoverflow.com/questions/49328382/browser-detection-in-reactjs

const getItemsFromSelectedValue = (selectedValue = "", items) => {
  return items.map(item => {
    item.isSelected = item.text.toLowerCase() === selectedValue.toLowerCase()
    return item
  })
}

class DropDownControl extends Component {
  constructor(props) {
    super(props);
    this.root = null;
    this.handleClickOutside = this.handleClickOutside.bind(this);

    let items = this.props.items.map((i, idx) => {
      return {text: i, index: idx}
    });

    let selectedValue = "";
    if (!this.props.selectedValue) {
      const selectedIndex = this.props.selectedIndex === null ? -1 : +this.props.selectedIndex;
      if (selectedIndex >= 0 && selectedIndex < items.length) {
        items[selectedIndex].isSelected = true;
        selectedValue = items[selectedIndex].text;
      }
    } else {
      selectedValue = this.props.selectedValue;
      items = getItemsFromSelectedValue(selectedValue, items);
    }
    this.state = {
      items,
      selectedValue,
      isExpanded: false,
      enabled: this.props.enabled !== undefined ? this.props.enabled : true,
      autoSetCurrentValue: this.props.autoSetCurrentValue === undefined ? true : this.props.autoSetCurrentValue
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.autoSetCurrentValue && this.state.items.length && nextProps.selectedValue
      && this.state.selectedValue && (nextProps.selectedValue !== this.state.selectedValue)) {
      this.setState({
        selectedValue: nextProps.selectedValue,
        items: getItemsFromSelectedValue(nextProps.selectedValue, this.state.items)
      })
    }
  }

  handleClickOutside = () => {
    this.setState({isExpanded: false});
  }

  setRoot = (node) => {
    this.root = node;
  }

  itemClick = (item, e) => {
    misc.ignoreDefault(e);
    if (!this.state.enabled) {
      return;
    }

    if (this.state.autoSetCurrentValue) {
      const items = getItemsFromSelectedValue(item.text, this.state.items);
      this.setState({
        selectedValue: item.text,
        items,
        isExpanded: false
      });
    } else {
      this.setState({isExpanded: false});
    }

    if (this.props.itemClick) {
      this.props.itemClick(item.text, item.index);
    }
  }

  toggleExpand = (e) => {
    misc.ignoreDefault(e);
    if (!this.state.enabled) {
      return;
    }

    this.setState({
      isExpanded: !this.state.isExpanded
    }, () => {
      if(this.root && !isIE) {
        this.root.focus();
      }
    });
  }

  doExpand = (expand) => {
    this.setState({isExpanded: expand});
  }

  render() {

    let styles = {};
    if (!this.state.enabled) {
      styles.backgroundColor = "gray";
    }

    return (
      <div className="job-board-dropdown-container" ref={(node) => { this.setRoot(node) }}
           tabIndex="1">
        <div className="job-board-dropdown-left-button" style={styles}
             onClick={(e) => this.toggleExpand(e)}/>
        <div className="job-board-dropdown-right-button" style={styles}
             onClick={(e) => this.toggleExpand(e)}>
          {this.props.renderIntl && this.state.selectedValue ? <FormattedMessage id={this.state.selectedValue}/> : this.state.selectedValue}
        </div>
        {this.state.isExpanded ? (
          <div className="job-board-drop-down-menu" key="dropdown">
            {this.state.items.map((item) => {
              return (
                <div className={"job-board-drop-down-lir" + (item.isSelected ? ' job-board-drop-down-lir-highlight' : '')}
                     key={item.text} onClick={(e) => this.itemClick(item, e)}>
                  {this.props.renderIntl && item.text ? <FormattedMessage id={item.text}/> : item.text}
                </div>
              )
            })}
          </div>
        ) : null}
      </div>
    )
  };
}

export default onClickOutside(DropDownControl)
